import { render, staticRenderFns } from "./ArtGallerytBasicCard.vue?vue&type=template&id=30e02ce6&"
import script from "./ArtGallerytBasicCard.vue?vue&type=script&lang=js&"
export * from "./ArtGallerytBasicCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtGallerytBasicCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports